import { useSelector } from "react-redux";
import { usePawsBraintreeCC } from "@urp/amplitude-experiments";
import { getBraintreeCCToggle } from "../redux/toggles";

/**
 * Braintree CC gate. Now that BRT is at 100% rollout, `isEnabled` routes to BRT
 * by default; only two things send card deposits to the legacy CCP processor:
 *   - the SGW `pawsBraintreeCC` kill-switch being off (the CCP rollback), or
 *   - Amplitude explicitly resolving the user to the `control` variant.
 * An unresolved / in-flight / failed / timed-out lookup no longer falls back to
 * CCP — it defaults to BRT (`isControl` is false until an explicit `control`
 * assignment lands).
 *
 * `isResolved` is false while the experiment fetch is in flight (SGW on) and
 * true once settled, or immediately when SGW is off. Callers should defer
 * side-effects (e.g. wallet fetch) until `isResolved` is true.
 */
export const useIsBraintreeEnabled = (): {
  isEnabled: boolean;
  isResolved: boolean;
} => {
  const isSgwBraintreeEnabled = useSelector(getBraintreeCCToggle);
  const { isControl, isResolved } = usePawsBraintreeCC();

  if (!isSgwBraintreeEnabled) return { isEnabled: false, isResolved: true };
  return { isEnabled: !isControl, isResolved };
};

export default useIsBraintreeEnabled;
